import styled from "styled-components";

export const Logo = styled.img<{ opacity?: number }>`
  width: ${props => props.width || "24"}px;
  height: ${props => props.height || "24"}px;
  opacity: ${props => props.opacity};
`;

export const Wrapper = styled.div`
  position: relative;
  box-shadow: 1px 1px 4px 0px rgba(152, 160, 171, 0.4);
  padding: 10px;
  transform: rotate(45deg);
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

export const InnerContent = styled.div`
  transform: rotate(-45deg);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Composition = styled.div`
  position: absolute;
  top: -13px;
  right: -13px;

  background-color: white;
  padding: 2px;
  border-radius: 360px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PlainServiceIconWrapper = styled.div`
  .service-icon-wrapper {
    position: relative;
    box-shadow: none;
    padding: 5px;
    transform: rotate(45deg);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--input-snow-background-color, var(--snow));
  }
`;
